import { DividerList, LabeledListItem } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { Tag } from '@optimus-web/core';
import { useActiveAccountingCategories } from '../../queries/useActiveAccountingCategories';
import { useAllowancesGet } from '../../queries/useAllowancesGet';

interface Props {
    allowanceId: string;
}
export const AllowanceAccountingTabContent = ({ allowanceId }: Props) => {
    const {
        allowanceProfitAccountingCategoryId,
        allowanceChargeAccountingCategoryId,
        allowanceCreditAccountingCategoryId,
    } = useAllowancesGet({
        allowanceId,
    });
    const activeAccountingCategories = useActiveAccountingCategories();

    const chargeAccountingCategory = activeAccountingCategories.find(
        ({ id }) => id === allowanceChargeAccountingCategoryId
    );

    const profitFromUnspentAllowanceCategory = activeAccountingCategories.find(
        ({ id }) => id === allowanceProfitAccountingCategoryId
    );

    const allowanceCreditAccountingCategory = activeAccountingCategories.find(
        ({ id }) => id === allowanceCreditAccountingCategoryId
    );

    return (
        <DividerList>
            <LabeledListItem label={lt('AllowanceAccountingCategoryCharge')}>
                {chargeAccountingCategory?.name ? (
                    <Tag variant="basicSubtle" outline>
                        {chargeAccountingCategory.name}
                    </Tag>
                ) : (
                    UnicodeEntity.Dash
                )}
            </LabeledListItem>
            <LabeledListItem label={lt('Consumption')}>
                {allowanceCreditAccountingCategory?.name ? (
                    <Tag variant="basicSubtle" outline>
                        {allowanceCreditAccountingCategory.name}
                    </Tag>
                ) : (
                    UnicodeEntity.Dash
                )}
            </LabeledListItem>
            <LabeledListItem label={lt('AllowanceAccountingCategoryProfit')}>
                {profitFromUnspentAllowanceCategory?.name ? (
                    <Tag variant="basicSubtle" outline>
                        {profitFromUnspentAllowanceCategory.name}
                    </Tag>
                ) : (
                    UnicodeEntity.Dash
                )}
            </LabeledListItem>
        </DividerList>
    );
};
